import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

/**
 * Schema for a single data point in the revenue per customer time series
 */
const revenueChartPointSchema_ = z.object({
  /** Date of the data point */
  date: zExt.plainDate(),
  /** Variant group revenue per customer for this period */
  variant: z.number(),
  /** Control group revenue per customer for this period */
  control: z.number(),
});
export const revenueChartPointSchema: z.ZodType<RevenueChartPoint> =
  revenueChartPointSchema_;
export interface RevenueChartPoint
  extends z.infer<typeof revenueChartPointSchema_> {}

export const getMarketingAgentRevenueChart = {
  name: "getMarketingAgentRevenueChart" as const,
  input: z.object({
    /** Number of days to include in the chart */
    days: z.number().int().positive(),
  }),
  output: z
    .object({
      /** Time series data points for the chart */
      data: z.array(revenueChartPointSchema),
    })
    .nullable(),
};
